<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
<!--                        {{ $tc('message.commonParameters', 2) }}-->
                        {{$t('message.parameter') }}

                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card-title">
                    <router-link :to="{ name: 'add-parameter-common',params:{ consultation: consultation_id} }" v-if="can">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>

                <template v-if="rows">
                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-col col sm="6">
                                <b-form-group>
                                    <autocomplete
                                            ref="autocomplete"
                                            :placeholder="$t('message.search')"
                                            :source="mParameters"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            @selected="itemSelected"
                                    ></autocomplete>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-table
                            id="parameters-table"
                            primary-key="id"
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            select-mode="single"
                            borderless
                            responsive
                            striped
                            hover
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            @row-selected="rowSelected"
                            :fields="fields"
                            :items="mParameters"
                    >
                        <!-- A virtual composite column for actions -->
                        <template slot="action" slot-scope="data">
                            <div class="row" v-if="data.item.isAuthor || hasAdminRole">
                                <div class="col-sm-6">
                                    <b-link :to="{ name: 'edit-parameter-common', params: { parameter: data.item.slug } }">
                                        <i class="fas fa-edit fa-2x edit-icon"></i>
                                    </b-link>
                                </div>

                                <div class="col-sm-6">
                                    <i v-b-modal="'delete-modal-' + data.item.slug" class="fas fa-trash fa-2x delete-icon"></i>
                                </div>
                            </div>

                            <b-modal
                                    :id="'delete-modal-' + data.item.slug"
                                    size="sm"
                                    header-bg-variant="danger"
                                    header-text-variant="light"
                                    :title="$t('message.delete') + ' ' + $tc('message.commonParameters', 1)"
                                    hide-footer
                            >
                                <div class="d-block text-center">
                                    <h3>{{ $t('message.delete') }} {{ data.item.type }}?</h3>
                                </div>

                                <div class="d-block float-right">
                                    <b-button variant="danger" @click="deleteParameter(data.item.slug)">
                                        {{ $t('message.delete') }}
                                    </b-button>

                                    <b-button variant="secondary" @click="$bvModal.hide('delete-modal-' + data.item.slug)">
                                        {{ $t('message.cancel') }}
                                    </b-button>
                                </div>
                            </b-modal>
                        </template>
                    </b-table>

                    <b-pagination
                            class="justify-content-center"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="parameters-table"
                    ></b-pagination>
                </template>

                <template v-else>
                    <div class="card">
                        <div class="card-body text-xs-center">
                            <p class="card-text">
                                {{ $t('message.noResults') }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: "Commons",

        computed: {
            ...mapGetters(["commonParameters", "hasAdminRole", "hasMedecinControleRole", "hasPraticienRole","hasAssistante"]),

            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },

            mParameters: function() {
                let pArray = [];

                _.forEach(this.commonParameters, function(parameter) {
                    let p = {};

                    p.poids = parameter.poids;
                    p.taille = parameter.taille;
                    p.temperature = parameter.temperature;
                    p.date = moment(parameter.created_at).format('YYYY/MM/DD HH:mm');
                    p.id = parameter.id;
                    p.slug = parameter.slug;

                    pArray.push(p);
                });

                return pArray;
            },

            rows: function() {
                return this.mParameters.length;
            }
        },

        data() {
            return {
                perPage: 10,
                currentPage: 1,
                sortBy: 'date',
                sortDesc: true,
                consultation_id: this.$route.params.consultation,
                fields: [
                    {
                        key: 'poids',
                        label: this.$i18n.t('message.weight'),
                    },
                    {
                        key: 'taille',
                        label: this.$i18n.t('message.height'),
                    },
                    {
                        key: 'temperature',
                        label: this.$i18n.t('message.temperature'),
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getParameters() {
                let args = {
                    offset: this.offset,
                    limit: this.limit,
                    consultation: this.consultation_id
                };

                this.$store.dispatch('getCommonParameters', { args : args });
            },

            formattedDisplay (result) {
                return result.poids + ' kg, ' + result.taille + ' cm';
            },

            rowSelected(items) {
                this.$router.push({ name: 'parameter-common', params: { parameter: items[0].slug } });
            },

            itemSelected(item) {
                this.$router.push({ name: 'parameter-common', params: { parameter: item.selectedObject.slug } });
            },

            deleteParameter(parameter) {
                let self = this;

                let args = {
                    parametreCommun: parameter
                };

                let successMessage = this.$i18n.t('message.commonParameterDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteCommonParameter', { args, index: parameter, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + parameter);
                    });
            }
        },

        mounted() {
            // Fetch common parameter list
            this.getParameters();
        }
    }
</script>

<style scoped>

</style>